import {Box} from '@mui/material'
import type {FC, ReactNode} from 'react'
import {StrictMode} from 'react'

type Props = {
  children: ReactNode
}

const BasicDashboardContainer: FC<Props> = ({children}) => (
  <StrictMode>
    <Box
      data-testid="mbai-basic-dashboard-container-box"
      sx={{height: '100%', minHeight: 0, display: 'flex', flexDirection: 'column'}}
    >
      <Box
        sx={{
          px: {
            sm: 3,
            xs: 2,
          },
          pb: {
            sm: 3,
            xs: 2,
          },
          pt: {
            sm: 2,
            xs: 1,
          },
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box sx={{flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column'}}>{children}</Box>
      </Box>
    </Box>
  </StrictMode>
)

export default BasicDashboardContainer
